import LevelCompletedSvg from "../object-graphics/LevelCompletedSvg";
import styles from "./PopupMessage.module.css";

export default function CompletedMessage() {
  return (
    <div className={styles.popupContainer}>
      <LevelCompletedSvg />
    </div>
  );
}
